import { Environment } from '@increasecard/increase-core';

type AppConfig = {
  apiUrl: string;
  mixpanelToken: string;
  appId: string;
  appSecret: string;
  authUrl: string;
  platformUrl: string;
  environment: Environment;
};

const Config: { [id: string]: AppConfig } = {
  production: {
    apiUrl: process.env.REACT_APP_CARD_API_URL as string,
    mixpanelToken: process.env.REACT_APP_MIXPANEL_TOKEN as string,
    appId: process.env.REACT_APP_APP_ID as string,
    appSecret: process.env.REACT_APP_APP_SECRET as string,
    authUrl: process.env.REACT_APP_AUTH_URL as string,
    platformUrl: process.env.REACT_APP_PLATFORM_API_URL as string,
    environment: 'production'
  },
  staging: {
    apiUrl: process.env.REACT_APP_CARD_API_URL as string,
    mixpanelToken: process.env.REACT_APP_MIXPANEL_TOKEN as string,
    appId: process.env.REACT_APP_APP_ID as string,
    appSecret: process.env.REACT_APP_APP_SECRET as string,
    authUrl: process.env.REACT_APP_AUTH_URL as string,
    platformUrl: process.env.REACT_APP_PLATFORM_API_URL as string,
    environment: 'staging'
  },
  development: {
    apiUrl: process.env.REACT_APP_CARD_API_URL as string,
    mixpanelToken: process.env.REACT_APP_MIXPANEL_TOKEN as string,
    appId: process.env.REACT_APP_APP_ID as string,
    appSecret: process.env.REACT_APP_APP_SECRET as string,
    authUrl: process.env.REACT_APP_AUTH_URL as string,
    platformUrl: process.env.REACT_APP_PLATFORM_API_URL as string,
    environment: 'development'
  }
};

export const environment: Environment = (process.env.REACT_APP_STAGE ||
  'development') as Environment;

export const productName = 'card';

export default Config[environment];
